export default __webpack_public_path__ + "static/media/(28).9f62cbb6.jpeg";